// styles.js (estilos do componente Ajuda)
import styled from "styled-components";

// Estilos do Modal de Ajuda
export const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '700px', // Aumentado de 500px para 700px
    padding: '0',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1001, // Garante que o modal fique sobre o header
  },
};

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  background-color: #f7f7f7;

  h2 {
    margin: 0;
    font-size: 1.25rem;
    color: #333;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    color: #888;

    &:hover {
      color: #333;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  max-height: 70vh; // Aumentado de 60vh para 70vh
  overflow-y: auto;
`;

export const HelpItem = styled.div`
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  strong {
    display: block;
    font-size: 1rem;
    color: #cf0505;
    margin-bottom: 5px;
  }

  a {
    font-size: 0.85rem; /* Letra menor */
    color: #333; /* Cor preta */
    text-decoration: none;
    word-break: break-all;
    display: flex;
    align-items: center;
    gap: 8px; /* Espaço entre o ícone e o texto */
    margin-top: 5px;

    &:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  }
`;